import { render, staticRenderFns } from "./ModalVerInscripcionesProgramaUniversidad.vue?vue&type=template&id=559db3fa"
import script from "./ModalVerInscripcionesProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalVerInscripcionesProgramaUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports